import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllBusinesssApi = `${version}/Business/getAll`;

export const state = Vue.observable({
    businesses: []
});

export const mutations = {
    async setBusinesses() {
        var res = await axios.post(`${getAllBusinesssApi}`, {});
        state.businesses = res.data.result;
    },
};